import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Decouples "the user wants to open a log file" from the component that owns
 * the hidden file input (AppComponent). Any component — the menu item, the
 * empty-state button on the charts tab, or a keyboard shortcut — can call
 * `requestOpen()`; AppComponent subscribes to `requests$` and triggers the
 * file picker.
 */
@Injectable({ providedIn: 'root' })
export class LogFileOpenRequester {
    private readonly requestsSubj = new Subject<void>();
    readonly requests$ = this.requestsSubj.asObservable();

    requestOpen() {
        this.requestsSubj.next();
    }
}
